<template>
  <div class="d-flex flex-column justify-content-end w-100">
    <label
      v-if="itemModel.vars.label"
      :class="
        'form-label' +
        (itemModel.vars.label_attr && itemModel.vars.label_attr.class ? ' ' + itemModel.vars.label_attr.class : '') +
        (itemModel.vars.required ? ' required' : '')
      "
    >
      {{ index ? index + ". " : "" }}{{ itemModel.vars.label }}{{ itemModel.vars.required ? "*" : "" }}
      <span
        v-if="itemModel.vars.help && !isMobile()"
        class="form-info"
        v-tooltip="{ title: itemModel.vars.help, textWrap: true }"
      >
        <FontAwesomeIcon icon="fa-light fa-circle-question" />
      </span>
    </label>
    <div v-if="isMobile() && itemModel.vars.help" class="form-info">
      <FontAwesomeIcon icon="fa-light fa-circle-question" />
      {{ itemModel.vars.help }}
    </div>
    <VueTelInput
      ref="telInput"
      v-model="itemModel.vars.value"
      :disabled="itemModel.vars.disabled"
      :inputOptions="options"
      :class="itemClass"
      :preferredCountries="preferredCountries"
      :defaultCountry="defaultCountry"
      :key="defaultCountry"
      mode="international"
      @blur="blur"
      @change="change"
      @close="detachFloatingList"
      @focus="focus"
      @input="input"
      @open="openDropdown"
      @validate="validate"
    />
    <div v-if="itemModel.vars.error" class="invalid-feedback d-block">{{ itemModel.vars.error }}</div>
  </div>
</template>

<script>
import { formValidator } from "@/services/form/form-validator";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { VueTelInput } from "vue-tel-input";
import { mapState } from "pinia";
import { useThemeStore } from "@/store/theme/theme";
import { floatingDropdownManager } from "@/services/utilities/floating-dropdown-manager";

export default {
  name: "PhoneTypeComponent",
  data() {
    return {
      itemModel: this.model,
      itemClass: "form-control phone-input",
      phone: "",
      load: false,
      preferredCountries: [],
      defaultCountry: "fr",
      validFormat: true,
      options: {
        id: this.model.vars.id,
        name: this.model.vars.name,
        required: this.model.vars.required,
        type: "tel",
        placeholder: this.model.vars.attr && this.model.vars.attr.placeholder ? this.model.vars.attr.placeholder : "",
      },
    };
  },
  emits: ["save", "draft", "focus", "update"],
  props: {
    model: {
      type: Object,
      required: true,
    },
    language: {
      type: String,
      required: false,
      default: "fr",
    },
    index: {
      type: Number,
      required: false,
      default: null,
    },
  },
  computed: {
    ...mapState(useThemeStore, {
      locale: (store) => store.locale,
    }),
  },
  watch: {
    "itemModel.vars.error"() {
      this.getClass();
    },
  },
  mounted() {
    this.preferredCountries = [this.locale];
    this.setDefaultCountry();
  },
  beforeUnmount() {
    this.detachFloatingList();
  },
  methods: {
    getClass() {
      if (
        (!this.validFormat &&
          (this.itemModel.vars.value || (!this.itemModel.vars.value && this.itemModel.vars.required))) ||
        formValidator.validModel(this.itemModel).length
      ) {
        this.itemClass =
          "form-control phone-input is-invalid " +
          (this.model.vars.attr && this.model.vars.attr.class ? this.model.vars.attr.class : "");
      } else {
        this.itemClass =
          "form-control phone-input is-valid " +
          (this.model.vars.attr && this.model.vars.attr.class ? this.model.vars.attr.class : "");
      }
    },

    blur() {
      this.valid(true);
      this.$emit("update", this.itemModel.vars.value, this.index);
    },

    input() {
      this.valid();
      this.$emit("update", this.itemModel.vars.value, this.index);
      this.$emit("draft", this.itemModel);
    },

    validate(object) {
      this.validFormat = object.valid;
      if (this.load) {
        this.valid();
      }
      this.load = true;
      this.$emit("update", this.itemModel.vars.value, this.index);
    },

    change() {
      this.valid();
      this.$emit("update", this.itemModel.vars.value, this.index);
    },

    focus() {
      this.$emit("focus");
    },

    openDropdown() {
      this.$nextTick(() => {
        this.detachFloatingList();
        const telInput = this.$refs.telInput;
        if (!telInput?.open) return;
        this.detachList = floatingDropdownManager.attach(telInput.$el, telInput.$refs.list, { allowAbove: true });
      });
    },

    detachFloatingList() {
      this.detachList?.();
      this.detachList = null;
    },

    isMobile() {
      return window.innerWidth < 992;
    },

    isPhoneValid() {
      if (this.validFormat && this.itemModel.vars.value) {
        this.validFormat = formValidator.validPhone(this.itemModel);
      }
    },

    valid(blur = false) {
      this.isPhoneValid();
      if (blur) {
        this.$emit("save");
      }
      this.getClass();
      if (!this.validFormat && this.model.vars.value) {
        this.itemModel.vars.error = this.$t("phoneError");
        this.itemModel.vars.isInvalid = true;
      } else {
        delete this.itemModel.vars.error;
        this.itemModel.vars.isInvalid = false;
        formValidator.validModel(this.itemModel, this.language);
      }
    },

    setDefaultCountry() {
      switch (this.locale) {
        case "fr":
        case "es":
          this.defaultCountry = this.locale;
          break;
        case "ca":
          this.defaultCountry = "es";
          break;
        case "en":
          this.defaultCountry = "gb";
          break;
      }
    },
  },
  components: {
    FontAwesomeIcon,
    VueTelInput,
  },
};
</script>

<style lang="scss" scoped>
.non-empty {
  overflow: auto;
}

.phone-input {
  padding: 0 30px 0 0;
  border-radius: 6px;
  border-color: $m-color_4;

  &.is-valid,
  &.is-invalid {
    padding: 0 30px 0 0;
  }
}
</style>
